module.exports = __webpack_public_path__ + "img/LinkedIN_white.955ed6eb.svg";